<template>
  <b-form-group
    label="Stant No"
    label-for="stand_no"
  >
    <validation-provider
      #default="{ errors }"
      name="Stant No"
      rules="required"
    >
      <b-form-input
        id="stand_no"
        v-model="dataItem.stand_no"
        placeholder="Stant No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'StandNoCards',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['fairs/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
